import { render, staticRenderFns } from "./QrCode.vue?vue&type=template&id=0c252c91"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"
import style0 from "./QrCode.vue?vue&type=style&index=0&id=0c252c91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports